import React, { useState, useEffect } from "react";
import axios from "axios";
import './NewProject.css';
import { useNavigate } from "react-router-dom";
import Dashboard from "../../dashboard/Dashboard";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileText, faFolderBlank, faUser } from "@fortawesome/free-solid-svg-icons";
import { getAuthToken } from "../../../utils/authStorage";
import { useUser } from "../../../context/UserContext";

const NewProject = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [clientId, setClientId] = useState("");
  const [clients, setClients] = useState([]);
  const [showClientSelector, setShowClientSelector] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newClientName, setNewClientName] = useState("");
  const [clientError, setClientError] = useState("");
  const [projectError, setProjectError] = useState("");
  const [isSavingClient, setIsSavingClient] = useState(false);
  const navigate = useNavigate();
  const [newClientLogo, setNewClientLogo] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { isViewer } = useUser();


  const token = getAuthToken();
  const authHeaders = () => ({ headers: { Authorization: `Bearer ${token}` } });
  const getErrorMessage = (err, fallback) => {
    if (err.response?.status === 409) {
      return "A client with that name already exists for this user. Please try a different name.";
    }

    const data = err.response?.data;
    if (typeof data === "string") return data;
    if (typeof data?.error === "string") return data.error;
    if (typeof data?.message === "string") return data.message;
    return fallback;
  };

  useEffect(() => {
    if (isViewer) {
      navigate("/projects", { replace: true });
      return;
    }

    const fetchUserInfo = async () => {
      try {
        const res = await axios.get("/api/users/me", authHeaders());
        const user = res.data;

        const userType = user.tipo || user.userType;
        if (userType === "ORGANIZACION" && user.selfClient?.id) {
          setClientId(user.selfClient.id);
          setShowClientSelector(true);
          fetchClients();
        } else {
          setShowClientSelector(true);
          fetchClients();
        }
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

    fetchUserInfo();
    console.log(clients);
  }, [isViewer, navigate]);

  const fetchClients = async () => {
    try {
      const res = await axios.get("/api/clients", authHeaders());

      setClients(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching user info:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProjectError("");
    try {
      console.log("Token: " + token)
      await axios.post(
        "/api/createProject",
        { name, description, clientId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            'Accept': 'application/json'
          }
        }
      );
      navigate("/projects");
    } catch (err) {
      console.error("Error creating project:", err);
      setProjectError(getErrorMessage(err, "Error creating project."));
    }
  };

  const handleCreateClient = async () => {
    const trimmedName = newClientName.trim();
    if (!trimmedName) {
      setClientError("Client name is required.");
      return;
    }

    setIsSavingClient(true);
    setClientError("");
    try {
      const formData = new FormData();
      formData.append("name", trimmedName);
      if (newClientLogo) {
        formData.append("logo", newClientLogo);
      }
      const res = await axios.post(
        "/api/clients",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      setClientId(res.data.id);
      setClients([...clients, res.data]);
      setNewClientName("");
      setNewClientLogo(null);
      setShowModal(false);
    } catch (err) {
      console.error("Error creating client:", err);
      setClientError(getErrorMessage(err, "Error creating client."));
    } finally {
      setIsSavingClient(false);
    }
  };

  return (
    <div>
      <div className="new-project-container">
        <h2>New Project</h2>
        <form onSubmit={handleSubmit} className="new-project-form">

          <label className="label">
            <FontAwesomeIcon icon={faFolderBlank} size="1x" />
            <h3 className="labelText">Project Name *</h3>
          </label>
          <input
            className="input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <label className="label">
            <FontAwesomeIcon icon={faFileText} size="1x" />
            <h3 className="labelText"> Description</h3>
          </label>
          <textarea
            className="textArea"
            value={description}
            placeholder="Add description here"
            onChange={(e) => setDescription(e.target.value)}
          />



          {showClientSelector && (
          <>
            <label className="label">
              <FontAwesomeIcon icon={faUser} size="1x" />
              <h3 className="labelText">Client *</h3>
            </label>
            <select className="selector" value={clientId} onChange={(e) => setClientId(e.target.value)} required>
              <option className="selectorPlaceHolder" value="">Select Client</option>
              {Array.isArray(clients) && clients.map((client) => (
                <option key={client.id} value={client.id}>{client.name}</option>
              ))}
            </select>
            <button type="button" className="small-button" onClick={() => setShowModal(true)}>
              + Add New Client
            </button>
          </>
          )} 

          <button type="submit" className="createButton">Create Project</button>
          {projectError && <p className="form-error">{projectError}</p>}


        </form>

        {showModal && (
          <div className="modal-overlay">
            <div className="modal">
              <h3>New Client</h3>
              <label className="modalLabel">
                <FontAwesomeIcon icon={faUser} size="1x" />
                <h3 className="labelText">Client´s name</h3>
              </label>
              <input
                className="input"
                type="text"
                placeholder="Client Name/Company Name"
                value={newClientName}
                onChange={(e) => {
                  setNewClientName(e.target.value);
                  setClientError("");
                }}
              />
              <label className="modalLabel">
                <FontAwesomeIcon icon={faUser} size="1x" />
                <h3 className="labelText">Upload client´s logo</h3>
              </label>
              <input
                type="file"
                accept="image/*"
                className="input"
                onChange={(e) => setNewClientLogo(e.target.files[0])}
              />
              {clientError && <p className="form-error">{clientError}</p>}
              <div className="modal-buttons">
                <button className="saveButton" onClick={handleCreateClient} disabled={isSavingClient}>
                  {isSavingClient ? "Saving..." : "Save"}
                </button>
                <button onClick={() => setShowModal(false)} className="cancel-button" disabled={isSavingClient}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewProject;
